import { Backdrop, CircularProgress } from "@mui/material";

const LoadingBackDrop = ({ openBackDrop }) => {
  return (
    <div>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openBackDrop}
      >
        <CircularProgress />
      </Backdrop>
    </div>
  );
};

export default LoadingBackDrop;
